import React, { FC, Fragment } from "react";
import { Divider, Grid, Stack, Typography } from "@mui/material";

import { CheckoutValue } from "../../../../store/Services/OrderApi/Types";

interface Props {
  value: CheckoutValue;
  currencySymbol: string;
}

export const PriceDetails: FC<Props> = ({ value, currencySymbol: c }) => {
  let checkoutValue = [{ label: "Subtotal", value: `${c} ${value.subtotal}` }];
  if (value.coupon) {
    checkoutValue = checkoutValue.concat([
      { label: "Coupon Discount", value: `${c} ${value.discount}` },
    ]);
  }
  checkoutValue = checkoutValue.concat([
    { label: "Taxes", value: `${c} ${value.taxes}` },
    { label: "Shipment Charges", value: `${c} ${value.shipmentCharges}` },
  ]);
  return (
    <Stack>
      <Typography variant="subtitle2">Price Details</Typography>
      <Grid container spacing={0.8} sx={{ mt: 0.5 }}>
        {checkoutValue.map((item, index) => (
          <Fragment key={index}>
            <Grid item xs={7}>
              <Typography variant="body2" component="p" fontWeight={500}>
                {item.label}
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography
                variant="body2"
                component="p"
                fontWeight={500}
                textAlign="right">
                {item.value}
              </Typography>
            </Grid>
          </Fragment>
        ))}
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={7}>
          <Typography variant="body1" component="p" fontWeight={700}>
            Total
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography
            variant="body1"
            component="p"
            fontWeight={700}
            textAlign="right">
            {c}
            {value.total}
          </Typography>
        </Grid>
      </Grid>
    </Stack>
  );
};
